export const MAX_EVENTS = 100
export const MESSAGE_TRUNCATE_LENGTH = 60
